import { t } from "@/i18n-js/instance";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { defaultData as h1DefaultData } from "../../../H1Block/H1BlockDefaultData";
import { defaultData as h2DefaultData } from "../../../H2Block/H2BlockDefaultData";
import { defaultData as h3DefaultData } from "../../../H3Block/H3BlockDefaultData";
import { defaultData as h4DefaultData } from "../../../H4Block/H4BlockDefaultData";
import { defaultData as h5DefaultData } from "../../../H5Block/H5BlockDefaultData";
import { defaultData as h6DefaultData } from "../../../H6Block/H6BlockDefaultData";

export const HEADING_TYPES = ["h1", "h2", "h3", "h4", "h5", "h6"] as const;
export type HeadingType = (typeof HEADING_TYPES)[number];

export const HEADING_DEFAULT_DATA: Readonly<Record<HeadingType, BaseBlock>> = {
  h1: h1DefaultData,
  h2: h2DefaultData,
  h3: h3DefaultData,
  h4: h4DefaultData,
  h5: h5DefaultData,
  h6: h6DefaultData,
};

export const TEXT_SELECT_OPTIONS = HEADING_TYPES.map(type => ({
  value: type,
  label: t(`builder_ui.block_type.${type}`),
}));
